import gql from 'graphql-tag';

export const AccountRoutinesFragment = gql`
  fragment AccountRoutinesFragment on account_GlobalSet {
    recommendedOn
    routinesSliderHeading
    routines: routineSlider {
      ...RoutinePreviewFragment
    }
  }
`;
